import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dis-gicirdatma-bruksizm-tedavisinde-botoks/page.tsx");
